// Authenticated fetch wrapper for the wealth-app.
//
// Every call to the api-proxy Lambda (anything under /api/*) goes
// through here so we can attach the current user's Cognito ID token
// as `Authorization: Bearer <jwt>`. The Lambda verifies the JWT
// against the User Pool's JWKS before it ever touches an upstream
// API — so unauthenticated browsers can no longer use the proxy to
// burn our balance.
//
// fetchAuthSession() from amplify auto-handles token refresh via the
// refresh token. If the refresh has also expired, it throws and the
// caller surfaces the error (the app's auth gate will then redirect
// the user back to LoginPage).

import { fetchAuthSession } from 'aws-amplify/auth';

export async function apiFetch(input, init = {}) {
  const session = await fetchAuthSession();
  const idToken = session?.tokens?.idToken?.toString();
  if (!idToken) {
    throw new Error('Not authenticated — sign in to continue.');
  }
  const headers = new Headers(init.headers || {});
  headers.set('Authorization', `Bearer ${idToken}`);
  return fetch(input, { ...init, headers });
}
